<template>
    <v-dialog v-model="dialogOpen" max-width="400">
      <v-card class="tw-pb-2">
        <v-card-title>ยืนยันเอกสาร</v-card-title>
        <v-card-text class="tw-tracking-normal tw-text-base tw-h-20">
          คุณแน่ใจหรือไม่ที่ต้องการยืนยัน ({{ selectedItems?.length }}) เอกสารที่เลือก?
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" class="tw-tracking-normal" @click="onConfirm">ยืนยัน</v-btn>
          <v-btn color="grey darken-1" outlined class="tw-tracking-normal" @click="close">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: "confirm-document-dialog",
    props: {
      isOpen: Boolean,
      selectedItems: Array,
    },
    computed: {
      dialogOpen: {
        get() {
          return this.isOpen;
        },
        set() {
          this.close();
        },
      },
    },
    methods: {
      close() {
        this.$emit("update:isOpen", false);
      },
      onConfirm() {
        this.$emit("confirm");
        this.close();
      },
    },
  };
  </script>
  